module.exports = __webpack_public_path__ + "static/media/music.1b6d4af.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/music.mp3
// module id = R+Fk
// module chunks = 9